import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const AVATARS = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=400&q=80",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=400&q=80",
];

export default function Testimonials() {
  const { t } = useLanguage();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0F0F0F] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-3xl">
          <p className="overline">{t.testimonials.overline}</p>
          <h2 className="font-display uppercase mt-4 text-4xl md:text-5xl tracking-tight">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {t.testimonials.items.map((item, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#0A0A0A] p-8 md:p-10 flex flex-col justify-between min-h-[340px]"
            >
              <Quote
                size={36}
                strokeWidth={1.4}
                className="text-redflag -ml-1"
              />
              <blockquote className="mt-6 text-lg md:text-xl leading-snug font-display uppercase tracking-tight text-white">
                "{item.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-white/10">
                <img
                  src={AVATARS[i]}
                  alt={item.name}
                  className="h-12 w-12 object-cover rounded-full grayscale-img"
                  loading="lazy"
                />
                <div>
                  <div className="font-medium text-sm text-white">
                    {item.name}
                  </div>
                  <div className="text-xs text-white/50 font-mono-plex uppercase tracking-widest">
                    {item.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
